export default {
  api: {
    companyRelationCompany: {
      sourceId: {
        notNull: "Something went wrong, we dont know the origin"
      },
      targetId: {
        notNull: "Select a company",
      },
      typeId: {
        notNull: "Select a type",
      },
    },
  },
}
